module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.certs), function(cert) {
    return _c('div', {
      key: cert.key,
      staticClass: "isoWrapper",
      on: {
        "click": function($event) {
          _vm.openCert(cert)
        }
      }
    }, [_c('img', {
      staticClass: "iso",
      attrs: {
        "src": cert.img,
        "alt": cert.alt
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9774706"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Certs.vue
// module id = 310
// module chunks = 0